export default function Services() {
  const services = [
    {
      title: 'Workstation Deployments',
      description: 'Deployment and configuration of desktops, laptops, monitors, and peripherals for office rollouts and refresh projects.',
      icon: 'ri-computer-line'
    },
    {
      title: 'Structured Cabling',
      description: 'Organized, labeled, and scalable cabling solutions for network infrastructure and hardware environments.',
      icon: 'ri-git-branch-line'
    },
    {
      title: 'Network Installations',
      description: 'Professional installation and setup of routers, switches, access points, and supporting equipment.',
      icon: 'ri-router-line'
    },
    {
      title: 'Office IT Relocations',
      description: 'Coordinated equipment relocation and redeployment for office expansions and transitions.',
      icon: 'ri-swap-box-line'
    }
  ];

  return (
    <section id="services-section" className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Core Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-zinc-900 rounded-lg p-8 hover:bg-zinc-800 transition-all duration-300 border border-zinc-800"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-orange-500/10 rounded-lg mb-6">
                <i className={`${service.icon} text-3xl text-orange-500`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
